import classes from "./PrimaryBanner.module.css";
import React, { useContext, useEffect, useState, memo } from "react";
import AuthContext from "../../store/auth-context";
import { t } from "../../locales/i18n";
import { images } from "../../assets/img";
import BookNowBtn from "../BookNowBtn";
import RemoteConfig from "../../services/RemoteConfig";
import { NAIL_SHOP_INFO } from "../../utils/Const";
import { useNavigate } from "react-router-dom";
import useCheckIsMobile from "../../hook/useCheckIsMobile";

const PrimaryBanner = (props) => {
  const {} = props || {};
  const navigate = useNavigate();
  const isMobile = useCheckIsMobile;

  return (
    <div className={classes.primaryBanner}>
      {/* <img
        className={`${classes.mainLogo}`}
        alt={"main logo"}
        src={images.main_logo}
      /> */}

      <div className={classes.centeredContainer}>
        <h1>{`Where Care Meets Elegance`}</h1>
        <h2>
          {`Experience nail treatments that blend precision, relaxation, and style. Whether you’re looking to refresh your everyday look or enjoy a moment of indulgence, our team is here to ensure your nails look stunning and you leave feeling renewed.`}
        </h2>
        <BookNowBtn />
      </div>

      <div
        style={{
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div style={{ flexDirection: "row" }}>
          {/* <a target={"_blank"} href={NAIL_SHOP_INFO.instagram} rel="noreferrer">
            <img
              className={classes.socialIcon}
              alt={"insta"}
              src={images.instaIcon}
            />
          </a> */}
          {/* <a target={"_blank"} href={NAIL_SHOP_INFO.facebook} rel="noreferrer">
            <img
              className={classes.socialIcon}
              alt={"insta"}
              src={images.fbIcon}
            />
          </a> */}
        </div>

        <div
          onClick={() => navigate("about-us")}
          style={{
            flexDirection: "row",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
        >
          <h3 style={{ textDecoration: "underline", color: "#fff" }}>
            See our collections
          </h3>
          <img
            className={classes.rightArrow}
            alt={"right-arrow"}
            src={images.leftArrow}
          />
        </div>
      </div>
    </div>
  );
};

export default memo(PrimaryBanner);
